import { SESSION_PROCESSING_CONTRACT } from '../sessionProcessingContract'

export type ProcessedFile = 'laps' | 'summary'

export interface ProcessedSummary {
  text: string
  runId: string
}

export interface ProcessedLaps {
  bytes: Uint8Array
  runId: string
}

export interface ProcessedFilesApi {
  getProcessedSummary(
    sessionId: string,
    versionKey: string
  ): Promise<ProcessedSummary | null>
  getProcessedLaps(
    sessionId: string,
    versionKey: string
  ): Promise<ProcessedLaps | null>
}

export function processedFileRoute(
  sessionId: string,
  versionKey: string,
  file: ProcessedFile
): string {
  const values: Record<string, string> = { sessionId, versionKey, file }
  return SESSION_PROCESSING_CONTRACT.processedFileRoute.replace(
    /\{(\w+)\}/g,
    (_, name: string) => values[name]
  )
}

const RUN_TAG = /^(?:W\/)?"([^"]+)"$/

export function runIdOf(tag: string | null | undefined): string | null {
  return RUN_TAG.exec(tag ?? '')?.[1] ?? null
}

export class UnnamedRunError extends Error {
  constructor(file: ProcessedFile) {
    super(`The processed ${file} names no run`)
    this.name = 'UnnamedRunError'
  }
}

export function runIdNamedBy(
  tag: string | null | undefined,
  file: ProcessedFile
): string {
  const runId = runIdOf(tag)
  if (runId === null) throw new UnnamedRunError(file)
  return runId
}
